import React from 'react';
import './settings.css'
import pic35 from '../../assets/pic35.png'
import pic36 from '../../assets/pic36.png'
import pic38 from '../../assets/pic38.png'
import pic41 from '../../assets/pic41.png'
import PrimaryctaLongsettings from './settings-primary-cta';
import SecondaryctaLongsettings from './settings-secondary-cta';
import AudioContext from './AudioContext';
import Howtoplay from './how to play';
import pic37 from '../../assets/pic37.png'  
import pic39 from '../../assets/pic39.png' 
import { useEffect } from 'react';
import { useState } from 'react';

const Settings = ({ onClose }) => {
    const [closing, setClosing] = useState(false);
     const { musicVolume, soundVolume, handleMusicVolume, setSoundVolume } = React.useContext(AudioContext);
    const [soundMuted, setSoundMuted] = useState(false);
    const [musicMuted, setMusicMuted] = useState(false);

 const prevSoundVolume = React.useRef(soundVolume);
    const prevMusicVolume = React.useRef(musicVolume);

    const toggleSound = () => {
        if (soundMuted) {
            setSoundVolume(prevSoundVolume.current);
        } else {
            prevSoundVolume.current = soundVolume;
            setSoundVolume(0);
        }
        setSoundMuted(m => !m);
    };

    const toggleMusic = () => {
        if (musicMuted) {
            handleMusicVolume(prevMusicVolume.current);
        } else {
            prevMusicVolume.current = musicVolume;
            handleMusicVolume(0);
        }
        setMusicMuted(m => !m);
    };

    useEffect(() => {
        setSoundMuted(soundVolume === 0);
    }, [soundVolume]);

    useEffect(() => {
        setMusicMuted(musicVolume === 0);
    }, [musicVolume]);


    const handleClose = () => {
        setClosing(true);
        setTimeout(() => onClose(), 400);
    };
        const [howtoplayOpen, sethowtoplayOpen] = useState(false);
    return ( 
        <>
            <section  className={`settings-background ${closing ? 'slide-down' : ''}`} onClick={handleClose}>
                {howtoplayOpen && <Howtoplay onClose={() => sethowtoplayOpen(false)} />}
                <section  className='settings-overlay' onClick={e => e.stopPropagation()}>

                <section className='header-overlay'>
                    <div className='header-title-cont-settings'>
                        <h2 className='title-containerr-settings'>Settings</h2>
                        <h2 className='title2-container-settings'>Settings</h2>
                    </div>
                    <button className='circlecta-cont'   onClick={handleClose}>
                    <div className='circle-red'>
                            <img className='close-img' src={pic35} alt='close'></img>
                    </div>
                    </button>
                </section>


                <section className='container-settings'>
                    <section className='container-audio'>

                            <section className='row-audio'>
                                <button className='circlecta-cont' onClick={toggleSound}>
                                    <img src={soundMuted ? pic37 : pic36} alt='sound'></img>
                                </button>
                                <div className='sliderr-sound'>
                                    <div className='slider-yellow' style={{ width: `${soundVolume * 85}%` }}></div>
                                    <input
                                        type='range' min='0' max='1' step='0.01'
                                        value={soundVolume}
                                        onChange={e => {
                                            setSoundVolume(parseFloat(e.target.value));
                                            setSoundMuted(false);
                                        }}
                                        className='slider-input'
                                    />
                                </div>
                            </section>

                            <section className='row-audio'>
                                <button className='circlecta-cont' onClick={toggleMusic}>
                                    <img src={musicMuted ? pic39 : pic38} alt='Music'></img>
                                </button>
                                <div className='sliderr-sound'>
                                    <div className='slider-yellow' style={{ width: `${musicVolume * 85}%` }}></div>
                                    <input
                                        type='range' min='0' max='1' step='0.01'
                                        value={musicVolume}
                                        onChange={e => {
                                            handleMusicVolume(parseFloat(e.target.value));
                                            setMusicMuted(false);
                                        }}
                                        className='slider-input'
                                    />
                                </div>
                            </section>


                    </section>


                    <img src={pic41} alt='line'></img>
                    <section className='container-audio'>

                        <PrimaryctaLongsettings title='How To play'  onClick={() => sethowtoplayOpen(true)}/>
                        <SecondaryctaLongsettings  title='Support' />
                    </section>


                </section>

                </section>
            </section>
        </>
     );
}
 
export default Settings;